import e from "./_DataView.js";
import a from "./_Map.js";
import o from "./_Promise.js";
import i from "./_Set.js";
import n from "./_WeakMap.js";
import S from "./_baseGetTag.js";
import t from "./_toSource.js";
var g = "[object Map]", T = "[object Object]", f = "[object Promise]", u = "[object Set]", w = "[object WeakMap]", b = "[object DataView]", j = t(e), C = t(a), M = t(o), d = t(i), v = t(n), r = S;
(e && r(new e(new ArrayBuffer(1))) != b || a && r(new a()) != g || o && r(o.resolve()) != f || i && r(new i()) != u || n && r(new n()) != w) && (r = function(c) {
  var m = S(c), p = m == T ? c.constructor : void 0, s = p ? t(p) : "";
  if (s)
    switch (s) {
      case j:
        return b;
      case C:
        return g;
      case M:
        return f;
      case d:
        return u;
      case v:
        return w;
    }
  return m;
});
const h = r;
export {
  h as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_getTag.js
// module id = 312
// module chunks = 67